"use client";

import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { DemoCTA } from "~/components/siteglue/siteglue-cta";
import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";
import { SITEGLUE_LIVE_DEMO_GALLERY_ROUTE } from "~/lib/siteglue/cta-config";
import { SITEGLUE_AI_EMPLOYEE_INDUSTRIES } from "~/lib/siteglue/ai-employees-showcase";
import { buildAgentsSearchUrl } from "~/lib/marketplace/constants";

const DEMO_INDUSTRIES = SITEGLUE_AI_EMPLOYEE_INDUSTRIES.filter((i) => i.id !== "all").slice(0, 8);

export function SiteGlueHomeDemos() {
  return (
    <HomeSection id="live-demos" tone="slate">
      <FadeIn className="mx-auto max-w-2xl text-center">
        <HomeEyebrow>Industry Live Demos</HomeEyebrow>
        <HomeHeading className="mx-auto">See SiteGlue in action for your industry.</HomeHeading>
        <HomeLead className="mx-auto">
          Explore live AI employees trained for real businesses—then hire your own.
        </HomeLead>
      </FadeIn>

      <ul className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {DEMO_INDUSTRIES.map((industry, i) => {
          const href = buildAgentsSearchUrl({
            category: industry.category,
            industry: industry.industry,
          });
          return (
            <FadeIn key={industry.id} delay={0.04 * i}>
              <li>
                <Link
                  href={href || SITEGLUE_LIVE_DEMO_GALLERY_ROUTE}
                  className="group flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-4 text-sm font-semibold text-slate-900 transition hover:border-[#4f81bd]/40 hover:shadow-sm"
                >
                  {industry.label}
                  <ArrowUpRight className="h-4 w-4 text-slate-400 transition group-hover:text-[#4f81bd]" />
                </Link>
              </li>
            </FadeIn>
          );
        })}
      </ul>

      <FadeIn className="mt-10 flex justify-center">
        <DemoCTA location="demo_card" size="lg" showArrow />
      </FadeIn>
    </HomeSection>
  );
}
